export class TestBarcodeResultItem {
    fileName = "";
    page = 0;
    value = "";
    foundByParams: number[];
}
